import { render, staticRenderFns } from "./cly-form-field-group.vue?vue&type=template&id=236f4da3"
import script from "./cly-form-field-group.vue?vue&type=script&lang=js"
export * from "./cly-form-field-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports